import React from 'react';
import { Accordion, Col, Form, Row } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../AdminModal.css';
import EditAccordionTable from './EditAccordionTable';
import { isAdmin } from '../../../features/localStorage';
import { useState } from '../../../assets/images/Mahindra _ Ethics & Governance Portal_files/vendors_main.chunk';

const CodeViolationAccordion = ({
  data,
  title,
  id,
  onDeleteCompany
}: {
  data: any;
  title?: any;
  id?: any;
  onDeleteCompany?: any;
}) => {
  //const [companyDeleteId, setcompanyDeleteId]=useState(0)
  const handleChangeCheckbox = (e: any) => {
    // to find out if it's checked or not; returns true or false
    const checked = e.target.checked;

    // to get the checked value
    const checkedValue = e.target.value;
    // setcompanyDeleteId(checkedValue)
    // console.log(checkedValue)
    // to get the checked name
    const checkedName = e.target.name;
    onDeleteCompany(checkedValue);
    //then you can do with the value all you want to do with it.
  };

  return (
    <>
      <Accordion flush>
        <Accordion.Item eventKey='0'>
          <Accordion.Header style={styles.title}>
            {isAdmin() && (
              <Form.Check
                type='checkbox'
                onChange={handleChangeCheckbox}
                id={id}
                value={id}
              />
            )}
            {title}
          </Accordion.Header>
          <Accordion.Body className='py-0'>
            <EditAccordionTable data={data} title={title} id={id} />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};

const styles: any = {
  title: {
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '500',
    color: '#242424',
    lineHeight: '2'
  }
};

export default CodeViolationAccordion;
